import { StyleSheet, Text, View, ViewStyle } from "react-native";
import { Colors, Typography } from "../../styles";
import { TimeOption } from "./Times";
import {
  Chart,
  Line,
  Area,
  HorizontalAxis,
  VerticalAxis,
} from "react-native-responsive-linechart";

const Graph = ({
  data,
  timeOption,
  style,
}: {
  data: number[];
  timeOption: TimeOption | undefined;
  style?: ViewStyle;
}) => {
  //#region Get num of days based on time option
  const timeOptionToDays: { [key in TimeOption]: number } = {
    "1w": 7,
    "2w": 14,
    "1m": 30,
    "2m": 60,
    max: 90,
  };
  if (!timeOption) timeOption = "max";
  const days = timeOptionToDays[timeOption];
  data = data.slice(-days);
  //#endregion

  const graphColor =
    data.length >= 2
      ? data[0] - data[data.length - 1] < 0
        ? Colors.teal700
        : Colors.coral700
      : Colors.teal700;

  const plotData: { x: number; y: number }[] = data.map((d, i) => ({
    x: i,
    y: d,
  }));

  const range = [
    Math.floor(Math.min(...data) / 10) * 10,
    Math.ceil(Math.max(...data) / 10) * 10,
  ];
  const ticks = [
    range[0],
    range[0] + (range[1] - range[0]) / 3,
    range[1] - (range[1] - range[0]) / 3,
    range[1],
  ];

  return (
    <View style={[styles.container, style]}>
      <View style={styles.ticks}>
        {ticks.map((t) => (
          <Text style={[Typography.paragraph, { fontSize: 12 }]}>
            {t.toFixed(0)}
          </Text>
        ))}
      </View>
      <Chart
        style={{ height: "100%", flex: 1 }}
        data={plotData}
        // padding={{ left: 100, bottom: 20, right: 20, top: 20 }}
        xDomain={{ min: 0, max: plotData.length - 1 }}
        yDomain={{ min: 0, max: Math.max(...plotData.map((d) => d.y)) }}
      >
        <VerticalAxis
          theme={{
            axis: {
              visible: false,
              stroke: {
                color: "#fff",
                opacity: 0.4,
              },
            },
            grid: { visible: false },
          }}
        />
        <HorizontalAxis
          theme={{
            axis: {
              visible: false,
              stroke: {
                color: "#fff",
                opacity: 0.4,
              },
            },
          }}
        />
        <Area
          theme={{
            gradient: {
              from: { color: graphColor, opacity: 0.6 },
              to: { color: graphColor, opacity: 0 },
            },
          }}
        />
        <Line
          theme={{
            stroke: { color: graphColor, width: 2 },
          }}
        />
      </Chart>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 100,
    flexDirection: "row",
  },
  ticks: {
    height: "100%",
    // width: 40,
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginRight: 5,
    opacity: 0.5,
  },
});

export default Graph;
